import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faFileImage, faPlayCircle, faSearch } from '@fortawesome/free-solid-svg-icons'

library.add(faUser, faFileImage, faPlayCircle, faSearch);